import React from "react";
import DateRange from "./DateRange";
import FilterElement from "./FilterElement";
import StatusFilter from "./StatusFilter";
import classes from "./Filter.module.css";
import CommonInput from "../../../CommonComponents/CommonInput";
import TuneIcon from "@mui/icons-material/Tune";
import { PropTypes } from "prop-types";
import CommonButton from "../../../CommonComponents/CommonButton";
import Grid from "@mui/system/Unstable_Grid/Grid";
import { Box } from "@mui/material";

const Filter = ({
  dateFilterHandler = () => {},
  statusFilterHandler = () => {},
  statusItemHandler = () => {},
  startDateHandler = () => {},
  endDateHandler = () => {},
  handleFilterByTag = () => {},
  handleFilterReset = () => {},
  handleFilterApply = () => {},
  isDateIconClicked,
  isDateFilterClicked,
  isStatusIconClicked,
  isStatusFilterClicked,
  isStatusItemClicked,
}) => {
  return (
    <div className={classes["main-filter-container"]} style={{}}>
      <FilterElement
        FilterLabel="Filter by Date"
        onClick={dateFilterHandler}
        isDateIconClicked={isDateIconClicked}
      />
      {isDateFilterClicked && (
        <DateRange
          startDateHandler={startDateHandler}
          endDateHandler={endDateHandler}
        />
      )}
      <FilterElement
        FilterLabel="Filter by Status"
        onClick={statusFilterHandler}
        isStatusIconClicked={isStatusIconClicked}
      />
      {isStatusFilterClicked && (
        <StatusFilter
          statusItemHandler={statusItemHandler}
          isStatusItemClicked={isStatusItemClicked}
        />
      )}
      <CommonInput
        sx={{ mt: "1rem", fontSize: "1.4rem" ,marginLeft:"1.2rem" , width:"95%"}}
        size="small"
        onKeyDown={handleFilterByTag}
        leftAlign
        placeholder="Filter by Tags"
        icon={<TuneIcon fontSize="large"></TuneIcon>}
      />
      <Box sx={{ display: "flex", justifyContent: "end" }}>
        <Grid container spacing={2} sx={{ mt: "1.2rem" }}>
          <Grid item>
            <CommonButton
              onClick={handleFilterReset}
              label="Reset"
              fontSize="1rem"
              borderRadius="1rem"
              removeBackGround
              boxShadow
              sx={{ padding: "0.4rem 1rem"  , border:"1px solid #E94D51" }}
            />
          </Grid>
          <Grid item>
            <CommonButton
              onClick={handleFilterApply}
              filledButton={true}
              label="Apply"
              fontSize="1rem"
              boxShadow
              borderRadius="1rem"
              sx={{ padding: "0.4rem 1rem" }}
            />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

Filter.prototypes = {
  dateFilterHandler: PropTypes.func,
  statusFilterHandler: PropTypes.func,
  statusItemHandler: PropTypes.func,
  startDateHandler: PropTypes.func,
  endDateHandler: PropTypes.func,
  handleFilterByTag: PropTypes.func,
  isDateIconClicked: PropTypes.bool,
  isDateFilterClicked: PropTypes.bool,
  isStatusIconClicked: PropTypes.bool,
  isStatusFilterClicked: PropTypes.bool,
};

export default Filter;
